

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SidebarLayout from '../pages/sideBarLayout';
import CashierHeader from './cashierHeader/cashHeader';

const MainLayout = ({ children }) => {
  const location = useLocation();

  const isShiftOpenOrCounterSelection = 
    location.pathname === "/Cashier/ShiftOpen" || 
    location.pathname === "/Cashier/CounterSelection";

  useEffect(() => {
    if (!isShiftOpenOrCounterSelection) {
      document.body.classList.add('body-with-sidebar');
    } else {
      document.body.classList.remove('body-with-sidebar');
    }
  }, [isShiftOpenOrCounterSelection]);

  return (
    <>
      {!isShiftOpenOrCounterSelection ? (
        <SidebarLayout>
          <CashierHeader />
          <div className='pt-5'>
            <div className='pt-5'>
              {children}
            </div>
          </div>
        </SidebarLayout>
      ) : (
        <div>
          <CashierHeader />
          <div className='pt-5'>
            <div className='pt-5'>
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MainLayout;

